package com.vidaensupalabra.vsp.ventanas

import androidx.compose.runtime.*
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.vidaensupalabra.vsp.ui.theme.*
import com.vidaensupalabra.vsp.datos.ComunidadPost
import com.vidaensupalabra.vsp.datos.ComunidadRepository
import com.vidaensupalabra.vsp.navigation.Router
import com.vidaensupalabra.vsp.navigation.Screen
import kotlinx.coroutines.launch

@Composable
fun PerfilScreen(
    targetUserId: String? = null,
    targetUserName: String? = null,
    targetUserPhoto: String? = null,
    onBack: () -> Unit
) {
    var currentUser by remember { mutableStateOf<FirebaseUser?>(null) }
    var userPosts by remember { mutableStateOf<List<ComunidadPost>>(emptyList()) }
    var isLoading by remember { mutableStateOf(true) }
    val coroutineScope = rememberCoroutineScope()

    val isOwnProfile = remember(targetUserId, currentUser) { targetUserId == null || (currentUser != null && targetUserId == currentUser!!.uid) }
    val displayUserId = remember(targetUserId, currentUser) { targetUserId ?: currentUser?.uid }
    val displayUserName = remember(targetUserName, currentUser) { targetUserName ?: currentUser?.name ?: "Usuario" }
    val displayUserPhoto = remember(targetUserPhoto, currentUser) { targetUserPhoto ?: currentUser?.photo }
    val totalAmens = remember(userPosts) { userPosts.sumOf { it.amens.size } }

    LaunchedEffect(displayUserId) {
        if (displayUserId != null) {
            coroutineScope.launch {
                isLoading = true
                userPosts = ComunidadRepository.getPostsByUser(displayUserId)
                isLoading = false
            }
        } else {
            userPosts = emptyList()
            isLoading = false
        }
    }

    LaunchedEffect(Unit) {
        if (window.asDynamic().addAuthChangeListener != undefined) {
            window.asDynamic().addAuthChangeListener { user: FirebaseUser? ->
                currentUser = user
            }
        }
    }

    Div(attrs = {
        style {
            width(100.percent)
            height(100.vh)
            backgroundColor(VspBase)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            fontFamily("sans-serif")
        }
    }) {
        // Header
        Div(attrs = {
            style {
                width(100.percent); padding(16.px); boxSizing("border-box")
                display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center)
                backgroundColor(VspMarcoTransparente50); property("border-bottom", "1px solid rgba(255,255,255,0.1)")
            }
        }) {
            Span(attrs = {
                onClick { onBack() }
                style { color(White); cursor("pointer"); fontSize(24.px) }
            }) { Text("⬅️") }
            H2(attrs = { style { color(White); margin(0.px); fontSize(24.px) } }) { Text(if (isOwnProfile) "Mi Cuenta" else "Perfil") }
            Div(attrs = { style { width(24.px) } }) // Elemento vacío para centrar el H2 flex-between
        }

        Div(attrs = {
            style {
                width(100.percent); maxWidth(800.px)
                flex(1); property("overflow-y", "auto")
                padding(16.px); boxSizing("border-box")
                display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(16.px)
            }
        }) {
            if (displayUserId == null && !isLoading) {
                if (!isLoading) {
                    Div(attrs = { style { textAlign("center"); marginTop(32.px) } }) {
                        P(attrs = { style { color(White); fontSize(18.px) } }) { Text("Aún no has iniciado sesión.") }
                        Button(attrs = {
                            onClick { window.asDynamic().signInWithGoogle() }
                            style { backgroundColor(White); color(Color("black")); border(0.px); borderRadius(8.px); padding(12.px, 24.px); fontWeight("bold"); cursor("pointer"); marginTop(16.px); fontSize(16.px) }
                        }) { Text("🔑 Ingresar con Google") }
                    }
                } else {
                    P(attrs = { style { color(White); textAlign("center") } }) { Text("Cargando perfil...") }
                }
            } else {
                // User Info Card
                Div(attrs = {
                    style {
                        backgroundColor(VspMarcoTransparente50); borderRadius(12.px); padding(24.px)
                        display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center)
                    }
                }) {
                    // Avatar con Fallback
                    if (displayUserPhoto != null) {
                        Img(src = displayUserPhoto, attrs = { style { width(80.px); height(80.px); borderRadius(50.percent); marginBottom(16.px); property("object-fit", "cover") } })
                    } else {
                        Div(attrs = {
                            style {
                                width(80.px); height(80.px); borderRadius(50.percent); marginBottom(16.px)
                                backgroundColor(VspMarco); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
                            }
                        }) {
                            Span(attrs = { style { color(White); fontSize(32.px); fontWeight("bold") } }) { Text(displayUserName.take(1).uppercase()) }
                        }
                    }
                    
                    H3(attrs = { style { color(White); margin(0.px, 0.px, 8.px, 0.px); fontSize(24.px) } }) { Text(displayUserName) }

                    // Panel de Estadísticas
                    Div(attrs = { style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceEvenly); width(100.percent); marginTop(16.px); padding(16.px, 0.px); property("border-top", "1px solid rgba(255,255,255,0.1)"); property("border-bottom", "1px solid rgba(255,255,255,0.1)") } }) {
                        StatItem("Aportes", userPosts.size)
                        StatItem("Amén Recibidos", totalAmens)
                    }
                    
                    if (isOwnProfile) {
                        Button(attrs = {
                            onClick { window.asDynamic().signOutFirebase() }
                            style { backgroundColor(Color("#EF5350")); color(White); border(0.px); borderRadius(8.px); padding(8.px, 16.px); fontWeight("bold"); cursor("pointer"); marginTop(16.px) }
                        }) { Text("Cerrar Sesión") }
                    }
                }

                H3(attrs = { style { color(VspMarco); marginTop(24.px); marginBottom(8.px); fontSize(20.px) } }) { Text(if (isOwnProfile) "Mis Aportes en la Comunidad" else "Aportes en la Comunidad") }

                if (isLoading) {
                    P(attrs = { style { color(White); textAlign("center") } }) { Text("Cargando aportes...") }
                } else if (userPosts.isEmpty()) {
                    P(attrs = { style { color(rgba(255,255,255,0.6)); textAlign("center") } }) { Text(if (isOwnProfile) "Aún no has publicado nada en la comunidad." else "Este usuario aún no ha publicado nada.") }
                } else {
                    userPosts.forEach { post ->
                        key(post.id) {
                            Div(attrs = {
                                onClick { Router.navigateTo(Screen.Comunidad(post)) }
                                style {
                                    backgroundColor(VspMarcoTransparente50); borderRadius(12.px); padding(16.px)
                                    property("box-shadow", "0px 4px 6px rgba(0,0,0,0.1)"); display(DisplayStyle.Flex)
                                    justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center)
                                    cursor("pointer")
                                }
                            }) {
                                H4(attrs = { style { color(White); margin(0.px); fontSize(16.px); flex(1); marginRight(12.px); property("display", "-webkit-box"); property("-webkit-line-clamp", "2"); property("-webkit-box-orient", "vertical"); property("overflow", "hidden") } }) { Text(post.titulo) }
                                Span(attrs = { style { color(rgba(255,255,255,0.5)); fontSize(12.px); property("white-space", "nowrap") } }) { Text(post.fecha) }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun StatItem(label: String, value: Int) {
    Div(attrs = { style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center) } }) {
        Span(attrs = { style { color(White); fontSize(20.px); fontWeight("bold") } }) { Text(value.toString()) }
        Span(attrs = { style { color(rgba(255,255,255,0.6)); fontSize(12.px); marginTop(4.px) } }) { Text(label) }
    }
}